module.exports = __webpack_public_path__ + "assets/img/modal-avatar-7ad98ff2.png";